import Immutable from 'immutable'

const initialState = Immutable.Map({}).set('isLoader', false)

/* Types */
export const INC_COUNTER_LOADER = 'INC_COUNTER_LOADER'
export const DEC_COUNTER_LOADER = 'DEC_COUNTER_LOADER'

/* Reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case INC_COUNTER_LOADER:
			return state.set('isLoader',true)
		case DEC_COUNTER_LOADER:
			return state.set('isLoader',false)
		default:
			return state
	}
}

/* Action Creators */
export const isLoader = (flag) => {
	return  (dispatch) => {
		if (flag) {
			dispatch({type: INC_COUNTER_LOADER})
		} else {
			dispatch({type: DEC_COUNTER_LOADER})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/Loader/index.js